// defaultTemplates.js

export const defaultTemplates = {

  'content-1': {
    name: 'Simple Blog Post Generator',
    description: 'Automatically generate and draft blog posts from a topic input',
    difficulty: 'Beginner',
    category: 'Content',
    workflow_data: {
      "nodes": [
        {
          "id": "trigger-1",
          "type": "trigger",
          "position": {
            "x": -392,
            "y": 7
          },
          "data": {
            "label": "Blog Topic Input",
            "triggerType": "manual",
            "content": "Enter blog post topic",
            "nodeName": "Subject",
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 377
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "ai-model-1",
          "type": "aiModel",
          "position": {
            "x": 131.0555462756637,
            "y": 75.5277731378319
          },
          "data": {
            "label": "Generate Outline",
            "model": "x-ai/grok-2-1212",
            "content": "Your job is to write an article about the [Input from trigger-1].\nThe article MUST be between 1300 and 1500 words long. And it should be optimized for SEO focused on the keyword of [Input from trigger-1740688253366]",
            "nodeName": "Article Content",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 131072
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "ai-model-2",
          "type": "aiModel",
          "position": {
            "x": 659.2806401807209,
            "y": 156.3806999596905
          },
          "data": {
            "label": "Write Blog Post",
            "model": "gpt-4o",
            "content": "Write a title for the following article following these rules:\n- Focus keyword must be in SEO title. Focus Keyword is: [Input from trigger-1740688253366]\n- Your title has a positive or a negative sentiment.\n- Your title contains 1 power word(s). \n- Your SEO title should contain a number.\n- Your title MUST be less than 60 characters.\n\nYou must return only the title without any remarks, notes, semicolons, or any other addition. \n\nArticle:\n[Input from ai-model-1]",
            "nodeName": "Title",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 747
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "post-1",
          "type": "post",
          "position": {
            "x": 1132.7499461668854,
            "y": 235.43207659082645
          },
          "data": {
            "label": "Create WordPress Post",
            "selectedPostType": "post",
            "postStatus": "draft",
            "fieldMappings": {
              "post_title": "[Input from ai-model-2]",
              "post_content": "[Input from ai-model-1]",
              "post_excerpt": "[Input from aiModel-1740689156946]"
            },
            "nodeName": "Draft Post",
            "editorPreferences": {
              "post_content": "plain"
            },
            "featuredImage": {
              "url": "[Input from unsplash-1740689860970]",
              "id": null,
              "source": "external"
            },
            "productImages": [],
            "workflowId": null
          },
          "measured": {
            "width": 400,
            "height": 794
          },
          "selected": true,
          "dragging": false
        },
        {
          "id": "trigger-1740688253366",
          "type": "trigger",
          "position": {
            "x": -359.1809282443206,
            "y": 463.3627892826421
          },
          "draggable": true,
          "data": {
            "triggerType": "manual",
            "selectedForm": null,
            "selectedFields": [],
            "selectedWorkflow": null,
            "selectedWpCoreTrigger": null,
            "wpCoreTriggerConditions": {},
            "selectedTable": null,
            "databaseTriggerType": null,
            "workflowId": null,
            "nodeName": "Keyword",
            "content": "Enter keyword for SEO optimization"
          },
          "measured": {
            "width": 380,
            "height": 377
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-1740689156946",
          "type": "aiModel",
          "position": {
            "x": 170.26991462758656,
            "y": 551.9956846120377
          },
          "draggable": true,
          "data": {
            "nodeName": "Meta Description",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 4096
            },
            "content": "Write an SEO-optimized meta description for the following article focusing on the [Input from trigger-1740688253366]. It should be a maximum of 170 characters. Return only the meta with no other text before or after it. The keyword should be enticing and should include sort of a CTA so users are compelled to click on it in Google SERP.\nArticle:\n[Input from ai-model-1]",
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "unsplash-1740689860970",
          "type": "unsplash",
          "position": {
            "x": 770.0357696498077,
            "y": 968.6669766388615
          },
          "draggable": true,
          "data": {
            "searchTerm": "[Input from trigger-1740688253366]",
            "workflowId": null,
            "orientation": "landscape",
            "previewUrl": "https://images.unsplash.com/photo-1542020345610-0f78cd3a9910?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w2NzE2ODd8MHwxfHNlYXJjaHwxfHwlNUJJbnB1dCUyMGZyb20lMjB0cmlnZ2VyLTE3NDA2ODgyNTMzNjYlNUR8ZW58MHwwfHx8MTc0MDY5MDM5OHww&ixlib=rb-4.0.3&q=80&w=200",
            "imageUrl": "https://images.unsplash.com/photo-1542020345610-0f78cd3a9910?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w2NzE2ODd8MHwxfHNlYXJjaHwxfHwlNUJJbnB1dCUyMGZyb20lMjB0cmlnZ2VyLTE3NDA2ODgyNTMzNjYlNUR8ZW58MHwwfHx8MTc0MDY5MDM5OHww&ixlib=rb-4.0.3&q=80&w=1080",
            "imageSize": "regular",
            "randomResult": false
          },
          "measured": {
            "width": 300,
            "height": 571
          },
          "selected": false,
          "dragging": false
        }
      ],
      "edges": [
        {
          "id": "e1-2",
          "source": "trigger-1",
          "target": "ai-model-1"
        },
        {
          "id": "e2-3",
          "source": "ai-model-1",
          "target": "ai-model-2"
        },
        {
          "id": "e3-4",
          "source": "ai-model-2",
          "target": "post-1"
        },
        {
          "id": "e4-5",
          "source": "trigger-1",
          "target": "post-1"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1740688253366",
          "sourceHandle": "a",
          "target": "ai-model-1",
          "id": "xy-edge__trigger-1740688253366a-ai-model-1"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1740688253366",
          "sourceHandle": "a",
          "target": "ai-model-2",
          "id": "xy-edge__trigger-1740688253366a-ai-model-2"
        },
        {
          "type": "default",
          "animated": false,
          "source": "ai-model-1",
          "sourceHandle": "a",
          "target": "post-1",
          "id": "xy-edge__ai-model-1a-post-1"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1",
          "sourceHandle": "a",
          "target": "aiModel-1740689156946",
          "id": "xy-edge__trigger-1a-aiModel-1740689156946"
        },
        {
          "type": "default",
          "animated": false,
          "source": "aiModel-1740689156946",
          "sourceHandle": "a",
          "target": "post-1",
          "id": "xy-edge__aiModel-1740689156946a-post-1"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1740688253366",
          "sourceHandle": "a",
          "target": "aiModel-1740689156946",
          "id": "xy-edge__trigger-1740688253366a-aiModel-1740689156946"
        },
        {
          "type": "default",
          "animated": false,
          "source": "ai-model-1",
          "sourceHandle": "a",
          "target": "aiModel-1740689156946",
          "id": "xy-edge__ai-model-1a-aiModel-1740689156946"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1740688253366",
          "sourceHandle": "a",
          "target": "unsplash-1740689860970",
          "id": "xy-edge__trigger-1740688253366a-unsplash-1740689860970"
        },
        {
          "type": "default",
          "animated": false,
          "source": "unsplash-1740689860970",
          "sourceHandle": "a",
          "target": "post-1",
          "id": "xy-edge__unsplash-1740689860970a-post-1"
        }
      ]
    }
  },

'content-blog-seo-generator': {
    name: 'SEO Optimized Blog Post Generator',
    description: 'Produces well-researched SEO optimized articles automatically.',
    difficulty: 'Intermediate',
    category: 'Content',
    workflow_data: {
      "nodes": [
        {
          "id": "trigger-1",
          "type": "trigger",
          "position": {
            "x": -1418,
            "y": -509
          },
          "data": {
            "triggerType": "manual",
            "content": "List your keywords here, separate them by commas.",
            "nodeName": "Keywords List"
          },
          "measured": {
            "width": 380,
            "height": 377
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "trigger-2",
          "type": "trigger",
          "position": {
            "x": -1454.445312621739,
            "y": -21.28999414612815
          },
          "data": {
            "triggerType": "manual",
            "content": "(Explain your company and it's services and our website address etc. )",
            "nodeName": "Company Information input"
          },
          "measured": {
            "width": 380,
            "height": 377
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-2",
          "type": "aiModel",
          "position": {
            "x": -548.3684749209879,
            "y": -345.72066791534303
          },
          "data": {
            "nodeName": "Blog Title",
            "model": "gpt-4o",
            "content": "From this list of blog post ideas, select the one that has the most potential to be a strong blog article. \nThen rewrite the blog post to make it SEO-friendly and fitting to my guidelines:\nThese are my guidelines for the topic:\n- It should be between 50 to 55 letters\n- Headlines that are strongly positive or negative tend to get more engagement than neutral ones. So it should not be neutral\n- Use at least one power word\n\nMake sure the blog title falls into one of these categories:\n- Top 10 Lists\n- How-To Guides\n- Ultimate Guides\n- Product Reviews and Comparisons\n- Industry Trends\n- Beginner's Guides\n- Expert Roundups\n- Myths and Misconceptions\n- Checklists\n- Step-by-Step Tutorials\n- Problem-Solution Posts\n\nReturn only the final blog title without quotation marks. \nBlog ideas:\n[[content] from research-1740693569572]",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 4096
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-4",
          "type": "aiModel",
          "position": {
            "x": -97.65006491467011,
            "y": 115.59438382916318
          },
          "data": {
            "nodeName": "keyword",
            "model": "openai/chatgpt-4o-latest",
            "content": "What's the main keyword for this blog title:\n[Input from aiModel-2]\n\nreturn only and only the keyword. nothing before or after it.",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-5",
          "type": "aiModel",
          "position": {
            "x": 496.0670152488708,
            "y": -204.25596500220678
          },
          "data": {
            "nodeName": "main blog post writer",
            "model": "x-ai/grok-2-1212",
            "content": "Content I want you to turn into a blog post:\n\"[[content] from research-1740692632938]\"\n\nThis should be written for Wordpress, include html formatting.\n\nI am writing a blog post with this information to show up for the following keyword: \"[Input from aiModel-4]\".\n\nIncorporate company information:\n[Input from trigger-2]",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 131072
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-6",
          "type": "aiModel",
          "position": {
            "x": 1007,
            "y": -528
          },
          "data": {
            "nodeName": "reading score improvement",
            "model": "openai/chatgpt-4o-latest",
            "content": "Rewrite the following article to improve the Flesch reading score to 60-70. Keep the structure and formatting, only improve readability:\n[Input from aiModel-5]",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false
        },
        {
          "id": "aiModel-7",
          "type": "aiModel",
          "position": {
            "x": 1039.7192484564323,
            "y": 49.40233872616062
          },
          "data": {
            "nodeName": "Meta description",
            "model": "openai/chatgpt-4o-latest",
            "content": "Generate a meta description (max 160 characters) with keyword '[Input from aiModel-4]' for article: '[Input from aiModel-2]'",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "post-1",
          "type": "post",
          "position": {
            "x": 1575,
            "y": -196
          },
          "data": {
            "selectedPostType": "post",
            "postStatus": "draft",
            "fieldMappings": {
              "post_title": "[Input from aiModel-2]",
              "post_content": "[Input from aiModel-6]",
              "post_excerpt": "[Input from aiModel-7]"
            },
            "nodeName": "Post post-1",
            "editorPreferences": {},
            "featuredImage": {
              "url": "",
              "id": null,
              "source": "external"
            },
            "productImages": [],
            "workflowId": null
          },
          "measured": {
            "width": 400,
            "height": 294
          },
          "selected": true,
          "dragging": false
        },
        {
          "id": "research-1740692632938",
          "type": "research",
          "position": {
            "x": -100.79818985368581,
            "y": -399.59921650383416
          },
          "draggable": true,
          "data": {
            "model": "sonar-pro",
            "temperature": 1,
            "searchContext": true,
            "citations": true,
            "searchDomainFilters": [],
            "citationQuality": "standard",
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "top_p": 1,
            "top_k": 0,
            "search_recency_filter": "any",
            "nodeName": "Research",
            "workflowId": null,
            "content": "I am writing a blog post with the title [Input from aiModel-2]. I want you to research the topic in details and provide me with the resources where you got those information so I can use it to write my blog.",
            "maxTokens": null
          },
          "measured": {
            "width": 380,
            "height": 459
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "research-1740693569572",
          "type": "research",
          "position": {
            "x": -970.850378581291,
            "y": -189.98236281297767
          },
          "draggable": true,
          "data": {
            "model": "sonar",
            "temperature": 1,
            "searchContext": true,
            "citations": true,
            "searchDomainFilters": [],
            "citationQuality": "standard",
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "top_p": 1,
            "top_k": 0,
            "search_recency_filter": "any",
            "nodeName": "Blog idea",
            "workflowId": null,
            "content": "This is my business:\n[Input from trigger-2].\nI want you to do research on these keywords online from competitors, and based on your findings and my line of work, suggest 5 top blog topics I should be writing about. \nkeywords:\n[Input from trigger-1]\n"
          },
          "measured": {
            "width": 380,
            "height": 459
          },
          "selected": false,
          "dragging": false
        }
      ],
      "edges": [
        {
          "id": "e1-2",
          "source": "trigger-1",
          "target": "aiModel-1"
        },
        {
          "id": "e2-3",
          "source": "trigger-2",
          "target": "aiModel-1"
        },
        {
          "id": "e3-4",
          "source": "aiModel-1",
          "target": "aiModel-2"
        },
        {
          "id": "e4-5",
          "source": "aiModel-2",
          "target": "aiModel-3"
        },
        {
          "id": "e4-6",
          "source": "aiModel-2",
          "target": "aiModel-4"
        },
        {
          "id": "e5-7",
          "source": "aiModel-3",
          "target": "aiModel-5"
        },
        {
          "id": "e6-7",
          "source": "aiModel-4",
          "target": "aiModel-5"
        },
        {
          "id": "e7-8",
          "source": "trigger-2",
          "target": "aiModel-5"
        },
        {
          "id": "e8-9",
          "source": "aiModel-5",
          "target": "aiModel-6"
        },
        {
          "id": "e4-10",
          "source": "aiModel-2",
          "target": "aiModel-7"
        },
        {
          "id": "e6-11",
          "source": "aiModel-4",
          "target": "aiModel-7"
        },
        {
          "id": "e12-13",
          "source": "aiModel-6",
          "target": "post-1"
        },
        {
          "id": "e13-14",
          "source": "aiModel-7",
          "target": "post-1"
        },
        {
          "type": "default",
          "animated": false,
          "source": "aiModel-2",
          "sourceHandle": "a",
          "target": "research-1740692632938",
          "id": "xy-edge__aiModel-2a-research-1740692632938"
        },
        {
          "type": "default",
          "animated": false,
          "source": "research-1740692632938",
          "sourceHandle": "a",
          "target": "aiModel-5",
          "id": "xy-edge__research-1740692632938a-aiModel-5"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-1",
          "sourceHandle": "a",
          "target": "research-1740693569572",
          "id": "xy-edge__trigger-1a-research-1740693569572"
        },
        {
          "type": "default",
          "animated": false,
          "source": "trigger-2",
          "sourceHandle": "a",
          "target": "research-1740693569572",
          "id": "xy-edge__trigger-2a-research-1740693569572"
        },
        {
          "type": "default",
          "animated": false,
          "source": "research-1740693569572",
          "sourceHandle": "a",
          "target": "aiModel-2",
          "id": "xy-edge__research-1740693569572a-aiModel-2"
        },
        {
          "type": "default",
          "animated": false,
          "source": "aiModel-2",
          "sourceHandle": "a",
          "target": "post-1",
          "id": "xy-edge__aiModel-2a-post-1"
        }
      ]
    }
  },


  'customer-service-ai': {
    name: 'AI-Powered Customer Service with Human Oversight',
    description: 'Process support tickets with AI assistance and your own data',
    difficulty: 'Advanced',
    category: 'Customer Service',
    workflow_data: {
      "nodes": [
        {
          "id": "trigger-1",
          "type": "trigger",
          "position": {
            "x": -838.1583820219023,
            "y": 251.84532134455534
          },
          "data": {
            "triggerType": "manual",
            "nodeName": "Customer Support Form",
            "content": "Select your support form that collects: Customer Name, Email, and Support Query. And map them to the nodes down the line. You can use GravityForms or Webhook triggers.",
            "selectedForm": null,
            "selectedFields": [],
            "selectedWorkflow": null,
            "selectedWpCoreTrigger": null,
            "wpCoreTriggerConditions": {},
            "selectedTable": null,
            "databaseTriggerType": null
          },
          "measured": {
            "width": 380,
            "height": 377
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "parser-1",
          "type": "parser",
          "position": {
            "x": -851.513815729568,
            "y": -317.81400449262344
          },
          "data": {
            "nodeName": "Knowledge Base Parser",
            "inputType": "upload",
            "parserSettings": {
              "language": "en",
              "skipDiagonalText": false,
              "doNotUnrollColumns": false,
              "parsingInstructions": "Extract all support-related information, procedures, and FAQs"
            },
            "documentLink": "",
            "uploadedFiles": [],
            "parsedContents": {},
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 478
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "aiModel-1",
          "type": "aiModel",
          "position": {
            "x": -347.93369887700254,
            "y": -146.13260224599486
          },
          "data": {
            "nodeName": "Response Generator",
            "model": "openai/chatgpt-4o-latest",
            "content": "Based on our knowledge base information and the customer's query, generate a helpful and accurate response.\n\nKnowledge Base Content:\n[Input from parser-1]\n\nCustomer Details:\nName: [Input from trigger-1]\nQuery: [Input from trigger-1]\n\nPlease provide a clear, concise, and friendly response that directly addresses the customer's question. Include specific references to our documentation where relevant.",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 433
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "humanInput-1",
          "type": "humanInput",
          "position": {
            "x": 92.68508763942418,
            "y": -101.1454921339486
          },
          "data": {
            "nodeName": "Support Team Review",
            "inputType": "modification",
            "assignmentType": "role",
            "selectedRole": "support",
            "content": "Please review and modify if needed the AI-generated response:\n\nCustomer Query:\n[Input from trigger-1]\n\nAI Response:\n[Input from aiModel-1]",
            "instructions": "Review the AI-generated response for accuracy and tone. Make any necessary modifications to ensure the response is helpful and aligns with our support standards.",
            "selectedUser": "",
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 925
          },
          "selected": true,
          "dragging": false
        },
        {
          "id": "aiModel-2",
          "type": "aiModel",
          "position": {
            "x": 556.4493662897994,
            "y": -165.98896179527512
          },
          "data": {
            "nodeName": "Email Formatter",
            "model": "openai/gpt-4o-mini",
            "content": "Format the following response into a professional email:\n\nCustomer Name: [Input from trigger-1]\nResponse: [Input from humanInput-1]\n\nFollow these guidelines:\n- Include a professional greeting using the customer's name\n- Format the response with proper paragraphs and spacing\n- Add a polite closing\n- Include a signature block",
            "imageUrls": [],
            "settings": {
              "temperature": 1,
              "top_p": 1,
              "top_k": 0,
              "frequency_penalty": 0,
              "presence_penalty": 0,
              "repetition_penalty": 1,
              "max_tokens": 16384
            },
            "workflowId": null
          },
          "measured": {
            "width": 380,
            "height": 671
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "sendEmail-1",
          "type": "sendEmail",
          "position": {
            "x": 994.6077483117017,
            "y": -177.4364764018458
          },
          "data": {
            "nodeName": "Send Response",
            "to": "[Input from trigger-1]",
            "subject": "Re: Your Support Query",
            "body": "<p>[Input from aiModel-2]</p>",
            "cc": "",
            "bcc": "",
            "useHtml": true,
            "attachments": [],
            "delayEnabled": false,
            "delayValue": 1,
            "delayUnit": "minutes",
            "workflowId": null
          },
          "measured": {
            "width": 400,
            "height": 722
          },
          "selected": false,
          "dragging": false
        },
        {
          "id": "output-1",
          "type": "output",
          "position": {
            "x": 830.5267056175219,
            "y": 598.7550921288794
          },
          "data": {
            "nodeName": "Save to Database",
            "outputType": "save",
            "selectedTable": "support_interactions",
            "columns": [],
            "webhookUrl": "",
            "displayOutput": "Output will be displayed here after execution",
            "delayEnabled": false,
            "delayValue": 1,
            "delayUnit": "minutes",
            "webhookKeys": [],
            "workflowId": null,
            "selectedSpreadsheet": "",
            "selectedSheetTab": "",
            "columnMappings": {},
            "driveItemType": ""
          },
          "measured": {
            "width": 380,
            "height": 535
          },
          "selected": false,
          "dragging": false
        }
      ],
      "edges": [
        {
          "id": "e1-2",
          "source": "parser-1",
          "target": "aiModel-1"
        },
        {
          "id": "e1-3",
          "source": "trigger-1",
          "target": "aiModel-1"
        },
        {
          "id": "e2-3",
          "source": "aiModel-1",
          "target": "humanInput-1"
        },
        {
          "id": "e3-4",
          "source": "trigger-1",
          "target": "humanInput-1"
        },
        {
          "id": "e4-5",
          "source": "humanInput-1",
          "target": "aiModel-2"
        },
        {
          "id": "e5-6",
          "source": "trigger-1",
          "target": "aiModel-2"
        },
        {
          "id": "e6-7",
          "source": "aiModel-2",
          "target": "sendEmail-1"
        },
        {
          "id": "e7-8",
          "source": "trigger-1",
          "target": "sendEmail-1"
        },
        {
          "id": "e8-9",
          "source": "sendEmail-1",
          "target": "output-1"
        },
        {
          "id": "e1-9",
          "source": "trigger-1",
          "target": "output-1"
        },
        {
          "id": "e3-9",
          "source": "humanInput-1",
          "target": "output-1"
        },
        {
          "id": "e2-9",
          "source": "aiModel-1",
          "target": "output-1"
        },
        {
          "id": "e5-9",
          "source": "aiModel-2",
          "target": "output-1"
        }
      ]
    }
},

'content-seo-optimizer': {
  name: 'Automated Post SEO Optimization',
  description: 'Loads a drafted post automatically, improves it for SEO and republishes it',
  difficulty: 'Advanced',
  category: 'Content',
  workflow_data: {
    "name": "Automated Post SEO Optimization",
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": -154,
          "y": 206
        },
        "data": {
          "triggerType": "wpCore",
          "nodeName": "Draft Post Monitor",
          "selectedWpCoreTrigger": "transition_post_status",
          "wpCoreTriggerConditions": {
            "fromStatus": "any",
            "toStatus": "draft",
            "postType": "post"
          }
        },
        "measured": {
          "width": 380,
          "height": 459
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 292,
          "y": -44
        },
        "data": {
          "nodeName": "Keyword Analysis",
          "model": "openai/chatgpt-4o-latest",
          "content": "Analyze this post to identify target keywords and semantic topics:\n\nTitle: [[post_title] from trigger-1]\nContent: [[post_content] from trigger-1]\nCategories: [[post_categories] from trigger-1]\nTags: [[post_tags] from trigger-1]\n\nList the main keyword, 3 secondary keywords, and 5 semantic topics. List one per line with a hyphen.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 599
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "research-1",
        "type": "research",
        "position": {
          "x": 250,
          "y": 592
        },
        "data": {
          "nodeName": "SEO Research",
          "model": "perplexity/llama-3.1-sonar-large-128k-online",
          "content": "Research current SEO best practices for the following keywords:\n\n[Input from aiModel-1]\n\nAnalyze and list:\n1. Optimal content structure\n2. Common heading patterns\n3. Related keywords\n4. Recommended content length\n5. Search intent patterns",
          "returnCitations": true,
          "maxTokens": 2000,
          "temperature": 0.7,
          "searchContext": true,
          "citations": true,
          "searchDomainFilters": [],
          "citationQuality": "standard",
          "frequency_penalty": 0,
          "presence_penalty": 0,
          "top_p": 1,
          "top_k": 0,
          "search_recency_filter": "any",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 629
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 770,
          "y": -76
        },
        "data": {
          "nodeName": "Title & Meta Creation",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create an SEO-optimized title and meta description:\n\nCurrent Title: [[post_title] from trigger-1]\nKeywords: [Input from aiModel-1]\nResearch: [Input from research-1]\n\nProvide two lines:\n1. Title (50-60 characters)\n2. Meta description (150-155 characters)",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 577
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-3",
        "type": "aiModel",
        "position": {
          "x": 768,
          "y": 530
        },
        "data": {
          "nodeName": "Content Optimizer",
          "model": "openai/chatgpt-4o-latest",
          "content": "Optimize this content for SEO while preserving its message:\n\nContent: [[post_content] from trigger-1]\nKeywords: [Input from aiModel-1]\nResearch: [Input from research-1]\n\nOptimize for:\n- Header structure (H2-H4)\n- Keyword placement\n- Content structure\n- Readability\n- Featured snippet potential",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 658
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "humanInput-1",
        "type": "humanInput",
        "position": {
          "x": 1234,
          "y": 68
        },
        "data": {
          "nodeName": "Editor Review",
          "inputType": "modification",
          "assignmentType": "role",
          "selectedRole": "editor",
          "content": "Original Title: [[post_title] from trigger-1]\nOptimized Title: [Input from aiModel-2]\n\nOriginal Content: [[post_content] from trigger-1]\nOptimized Content: [Input from aiModel-3]\n\nKeywords and Topics:\n[Input from aiModel-1]",
          "instructions": "Review and adjust the optimized content. Ensure it maintains quality while improving SEO. At the end remove the excess, and only approve the content that will be published.",
          "selectedUser": "",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 947
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "post-1",
        "type": "post",
        "position": {
          "x": 1675,
          "y": 224
        },
        "data": {
          "nodeName": "Update Post",
          "selectedPostType": "post",
          "postStatus": "draft",
          "fieldMappings": {
            "post_title": "[Input from aiModel-2]",
            "post_content": "[Input from humanInput-1]",
            "post_excerpt": "[Input from aiModel-2]",
            "_yoast_wpseo_metadesc": "[Input from aiModel-2]"
          },
          "editorPreferences": {},
          "featuredImage": {
            "url": "",
            "id": null,
            "source": "external"
          },
          "productImages": [],
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 294
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "aiModel-1"
      },
      {
        "id": "e1-4",
        "source": "trigger-1",
        "target": "aiModel-2"
      },
      {
        "id": "e1-5",
        "source": "trigger-1",
        "target": "aiModel-3"
      },
      {
        "id": "e1-6",
        "source": "trigger-1",
        "target": "humanInput-1"
      },
      {
        "id": "e2-3",
        "source": "aiModel-1",
        "target": "research-1"
      },
      {
        "id": "e2-6",
        "source": "aiModel-1",
        "target": "humanInput-1"
      },
      {
        "id": "e3-4",
        "source": "research-1",
        "target": "aiModel-2"
      },
      {
        "id": "e4-5",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e5-6",
        "source": "research-1",
        "target": "aiModel-3"
      },
      {
        "id": "e6-7",
        "source": "aiModel-1",
        "target": "aiModel-3"
      },
      {
        "id": "e7-8",
        "source": "aiModel-2",
        "target": "humanInput-1"
      },
      {
        "id": "e8-9",
        "source": "aiModel-3",
        "target": "humanInput-1"
      },
      {
        "id": "e4-10",
        "source": "aiModel-2",
        "target": "post-1"
      },
      {
        "id": "e9-10",
        "source": "humanInput-1",
        "target": "post-1"
      }
    ]
  }
},

'content-translation-service': {
  name: 'Automated Content Translation Service',
  description: 'Translates your content contextually into any language you choose',
  difficulty: 'Intermediate',
  category: 'Content',
  workflow_data: {
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": -4.313809598540843,
          "y": 197.33557448448028
        },
        "data": {
          "triggerType": "wpCore",
          "selectedWpCoreTrigger": "publish_post",
          "wpCoreTriggerConditions": {
            "postType": "any"
          },
          "nodeName": "Content Published Trigger"
        },
        "measured": {
          "width": 380,
          "height": 371
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "trigger-2",
        "type": "trigger",
        "position": {
          "x": 0,
          "y": 628.3041300730225
        },
        "data": {
          "triggerType": "manual",
          "content": "Enter target languages as comma-separated ISO codes (e.g.: es,fr,de,it,ja,ko,zh)",
          "nodeName": "Target Languages"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 461.04889167885926,
          "y": 218.36539627736693
        },
        "data": {
          "nodeName": "Content Translation",
          "model": "openai/chatgpt-4o-latest",
          "content": "Translate this content professionally:\n\nTitle: [[post_title] from trigger-1]\nContent: [[post_content] from trigger-1]\nExcerpt: [[post_excerpt] from trigger-1]\nCategories: [[post_categories] from trigger-1]\nTags: [[post_tags] from trigger-1]\n\nTarget Language: [Input from trigger-2]\n\nImportant rules:\n1. Preserve all HTML tags and formatting\n2. Don't translate URLs or code blocks\n3. Maintain technical terminology accuracy\n4. Ensure natural language flow\n5. Adapt for cultural context\n\nProvide the translation with clear section markers:\nTITLE:\nCONTENT:\nEXCERPT:\nCATEGORIES:\nTAGS:",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 586
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 461.9580928466921,
          "y": 839.5539784672521
        },
        "data": {
          "nodeName": "URL Slug Generator",
          "model": "openai/gpt-4o-mini",
          "content": "Generate an SEO-friendly URL slug in the target language:\n\nTranslated Title: [Input from aiModel-1]\nLanguage: [Input from trigger-2]\n\nCreate a URL-safe slug using only lowercase letters, numbers, and hyphens. Keep it under 60 characters.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "humanInput-1",
        "type": "humanInput",
        "position": {
          "x": 900,
          "y": 224.83611067517825
        },
        "data": {
          "inputType": "modification",
          "assignmentType": "role",
          "selectedRole": "editor",
          "content": "=== TRANSLATION REVIEW ===\n\nLanguage: [Input from trigger-2]\n\nOriginal:\nTitle: [[post_title] from trigger-1]\nExcerpt: [[post_excerpt] from trigger-1]\n\nTranslation:\n[Input from aiModel-1]\n\nURL Slug: [Input from aiModel-2]\n\nOriginal Post ID: [[post_id] from trigger-1]",
          "instructions": "Review the translation for accuracy, cultural appropriateness, and formatting integrity. Make any necessary modifications.",
          "selectedUser": "",
          "nodeName": "Human Input humanInput-1",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 931
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "post-1",
        "type": "post",
        "position": {
          "x": 1343.7936532846954,
          "y": 708.7017539781792
        },
        "data": {
          "selectedPostType": "post",
          "postStatus": "publish",
          "fieldMappings": {
            "post_title": "[Input from humanInput-1]",
            "post_content": "[Input from humanInput-1]",
            "post_excerpt": "[Input from humanInput-1]",
            "post_name": "[Input from aiModel-2]",
            "_translated_from": "[[post_id] from trigger-1]",
            "_translation_lang": "[Input from trigger-2]",
            "_original_language": "en"
          },
          "nodeName": "Create Translated Post",
          "editorPreferences": {},
          "featuredImage": {
            "url": "",
            "id": null,
            "source": "external"
          },
          "productImages": [],
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 794
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "output-1",
        "type": "output",
        "position": {
          "x": 1456.8619040145918,
          "y": 226.99301547444878
        },
        "data": {
          "outputType": "display",
          "nodeName": "Translation Complete",
          "content": "Translation published successfully!\n\nLanguage: [Input from trigger-2]\nOriginal Post: [[post_title] from trigger-1] (ID: [[post_id] from trigger-1])\nTranslation URL: [Input from aiModel-2]\n\nThe posts are linked via meta data for easy navigation.",
          "selectedTable": "",
          "webhookUrl": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "columns": [],
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 427
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "aiModel-1"
      },
      {
        "id": "e2-3",
        "source": "trigger-2",
        "target": "aiModel-1"
      },
      {
        "id": "e3-4",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e4-5",
        "source": "trigger-2",
        "target": "aiModel-2"
      },
      {
        "id": "e5-6",
        "source": "aiModel-1",
        "target": "humanInput-1"
      },
      {
        "id": "e6-7",
        "source": "aiModel-2",
        "target": "humanInput-1"
      },
      {
        "id": "e7-8",
        "source": "trigger-1",
        "target": "humanInput-1"
      },
      {
        "id": "e8-9",
        "source": "trigger-2",
        "target": "humanInput-1"
      },
      {
        "id": "e9-10",
        "source": "humanInput-1",
        "target": "post-1"
      },
      {
        "id": "e10-11",
        "source": "aiModel-2",
        "target": "post-1"
      },
      {
        "id": "e11-12",
        "source": "post-1",
        "target": "output-1"
      },
      {
        "id": "e1-9",
        "source": "trigger-1",
        "target": "post-1"
      },
      {
        "id": "e2-9",
        "source": "trigger-2",
        "target": "post-1"
      },
      {
        "id": "e1-12",
        "source": "trigger-1",
        "target": "output-1"
      },
      {
        "id": "e2-12",
        "source": "trigger-2",
        "target": "output-1"
      },
      {
        "id": "e4-12",
        "source": "aiModel-2",
        "target": "output-1"
      }
    ]
  }
},

'sales-lead-qualification': {
  name: 'Lead Qualification System',
  description: 'Automatically does research on your sales leads, scores them, and prioritises them for you',
  difficulty: 'Advanced',
  category: 'Sales',
  workflow_data: {
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": 0,
          "y": 250
        },
        "data": {
          "triggerType": "manual",
          "content": "Enter lead information:\n\nName:\nEmail:\nCompany:\nJob Title:\nIndustry:\nBudget Range:\nTimeline:\nProject Description:\nSource:",
          "nodeName": "Lead Input Form"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": true
      },
      {
        "id": "trigger-2",
        "type": "trigger",
        "position": {
          "x": -4.887045378421249,
          "y": 648.7398453891326
        },
        "data": {
          "triggerType": "manual",
          "content": "Enter your business criteria:\n\n1. Ideal Customer Profile (industries):\n2. Minimum Budget Requirements:\n3. Preferred Timeline:\n4. Priority Features/Requirements:\n5. Deal Breakers:\n6. Geographic Preferences:",
          "nodeName": "Business Criteria"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "research-1",
        "type": "research",
        "position": {
          "x": 433.57924034351527,
          "y": 238.59689411701703
        },
        "data": {
          "nodeName": "Prospect Research",
          "model": "perplexity/llama-3.1-sonar-large-128k-online",
          "content": "Research the prospect and their company:\n\nCompany: [Input from trigger-1]\nContact Name: [Input from trigger-1]\n\nResearch and analyze:\n1. Company size and revenue\n2. Recent company news and developments\n3. Market position and competitors\n4. Technology stack and current solutions\n5. Growth trajectory\n6. Key decision makers\n7. Social media presence\n8. Recent partnerships or initiatives",
          "returnCitations": true,
          "maxTokens": 2000,
          "temperature": 0.7,
          "searchContext": true,
          "citations": true,
          "searchDomainFilters": [],
          "citationQuality": "standard",
          "frequency_penalty": 0,
          "presence_penalty": 0,
          "top_p": 1,
          "top_k": 0,
          "search_recency_filter": "any",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 459
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 430.5824268813951,
          "y": 717.5273412023037
        },
        "data": {
          "nodeName": "Lead Analysis",
          "model": "openai/chatgpt-4o-latest",
          "content": "Analyze this lead based on all available information:\n\nLead Information:\n[Input from trigger-1]\n\nBusiness Criteria:\n[Input from trigger-2]\n\nMarket Research:\n[Input from research-1]\n\nProvide scoring (1-10) for each category:\n- Budget Fit: \n- Timeline Alignment: \n- Industry Match: \n- Project Scope Fit: \n- Decision Maker Level: \n- Geographic Fit: \n- Resource Requirements: \n- Market Position: \n- Growth Potential: \n- Technical Alignment: \n\nAdditional Insights:\n",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 857.6456067203487,
          "y": 188.09742520666367
        },
        "data": {
          "nodeName": "Score Calculator",
          "model": "openai/chatgpt-4o-latest",
          "content": "Calculate final lead score (0-100):\n\nAnalysis:\n[Input from aiModel-1]\n\nReturn only the numerical score.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "condition-1",
        "type": "condition",
        "position": {
          "x": 907.9740343107183,
          "y": 665.5816471160693
        },
        "data": {
          "nodeName": "Priority Check",
          "conditions": [
            {
              "input": "[Input from aiModel-2]",
              "comparison": "contains",
              "value": "75"
            }
          ],
          "conditionGroups": [
            {
              "type": "AND",
              "conditions": [
                {
                  "input": "",
                  "comparison": "equals",
                  "value": ""
                }
              ]
            }
          ],
          "workflowId": null
        },
        "measured": {
          "width": 350,
          "height": 425
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-3",
        "type": "aiModel",
        "position": {
          "x": 1357.5050622207873,
          "y": 91.50506222078747
        },
        "data": {
          "nodeName": "High Priority Brief",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create a sales brief for this high-priority lead:\n\nLead Details:\n[Input from trigger-1]\n\nMarket Research:\n[Input from research-1]\n\nAnalysis:\n[Input from aiModel-1]\n\nScore: [Input from aiModel-2]\n\nProvide:\n1. Key Opportunity Points\n2. Recommended Approach\n3. Potential Objections & Responses\n4. Competitive Advantages\n5. Suggested Timeline",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-4",
        "type": "aiModel",
        "position": {
          "x": 1379.9664998247968,
          "y": 894.0191866324801
        },
        "data": {
          "nodeName": "Nurture Plan",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create a nurturing plan:\n\nLead Details:\n[Input from trigger-1]\n\nMarket Research:\n[Input from research-1]\n\nAnalysis:\n[Input from aiModel-1]\n\nScore: [Input from aiModel-2]\n\nOutline:\n1. Content Recommendations\n2. Follow-up Schedule\n3. Education Points\n4. Qualification Steps",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "sendEmail-1",
        "type": "sendEmail",
        "position": {
          "x": 1851.142107849365,
          "y": -152.02240646922615
        },
        "data": {
          "nodeName": "Sales Notification",
          "to": "sales@company.com",
          "subject": "High Priority Lead - [Input from trigger-1]",
          "body": "<p>New High Priority Lead Alert Score: [Input from aiModel-2] Research Insights: [Input from research-1] Sales Brief: [Input from aiModel-3] Lead Details: [Input from trigger-1]</p>",
          "cc": "",
          "bcc": "",
          "useHtml": true,
          "attachments": [],
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 722
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "output-1",
        "type": "output",
        "position": {
          "x": 1833.0838008934802,
          "y": 613.385825781795
        },
        "data": {
          "outputType": "save",
          "nodeName": "Lead Database",
          "selectedTable": "leads_tracker",
          "columns": [],
          "fieldMappings": {
            "lead_date": "=NOW()",
            "lead_data": "[Input from trigger-1]",
            "research_data": "[Input from research-1]",
            "lead_score": "[Input from aiModel-2]",
            "analysis": "[Input from aiModel-1]",
            "priority": "[Input from condition-1]",
            "next_steps": "[Input from aiModel-3]"
          },
          "webhookUrl": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 535
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "research-1"
      },
      {
        "id": "e2-3",
        "source": "research-1",
        "target": "aiModel-1"
      },
      {
        "id": "e3-4",
        "source": "trigger-1",
        "target": "aiModel-1"
      },
      {
        "id": "e4-5",
        "source": "trigger-2",
        "target": "aiModel-1"
      },
      {
        "id": "e5-6",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e6-7",
        "source": "aiModel-2",
        "target": "condition-1"
      },
      {
        "id": "e7-8",
        "source": "condition-1",
        "target": "aiModel-3",
        "sourceHandle": "true"
      },
      {
        "id": "e8-9",
        "source": "condition-1",
        "target": "aiModel-4",
        "sourceHandle": "false"
      },
      {
        "id": "e9-10",
        "source": "aiModel-3",
        "target": "sendEmail-1"
      },
      {
        "id": "e10-11",
        "source": "research-1",
        "target": "sendEmail-1"
      },
      {
        "id": "e11-12",
        "source": "trigger-1",
        "target": "output-1"
      },
      {
        "id": "e12-13",
        "source": "research-1",
        "target": "output-1"
      },
      {
        "id": "e13-14",
        "source": "aiModel-1",
        "target": "output-1"
      },
      {
        "id": "e14-15",
        "source": "aiModel-2",
        "target": "output-1"
      },
      {
        "id": "e15-16",
        "source": "condition-1",
        "target": "output-1"
      },
      {
        "id": "e16-17",
        "source": "aiModel-3",
        "target": "output-1"
      },
      {
        "id": "e17-18",
        "source": "trigger-1",
        "target": "aiModel-3"
      },
      {
        "id": "e18-19",
        "source": "research-1",
        "target": "aiModel-3"
      },
      {
        "id": "e19-20",
        "source": "aiModel-1",
        "target": "aiModel-3"
      },
      {
        "id": "e20-21",
        "source": "aiModel-2",
        "target": "aiModel-3"
      },
      {
        "id": "e21-22",
        "source": "trigger-1",
        "target": "aiModel-4"
      },
      {
        "id": "e22-23",
        "source": "research-1",
        "target": "aiModel-4"
      },
      {
        "id": "e23-24",
        "source": "aiModel-1",
        "target": "aiModel-4"
      },
      {
        "id": "e24-25",
        "source": "aiModel-2",
        "target": "aiModel-4"
      },
      {
        "id": "e25-26",
        "source": "trigger-1",
        "target": "sendEmail-1"
      },
      {
        "id": "e26-27",
        "source": "aiModel-2",
        "target": "sendEmail-1"
      },
      {
        "id": "e27-28",
        "source": "aiModel-4",
        "target": "output-1"
      }
    ]
  }
},

'feedback-sentiment-analysis': {
  name: 'Customer Feedback Sentiment Analyzer',
  description: 'Monitors for comments on posts, analyzes the sentiment, and drafts a response for you',
  difficulty: 'Intermediate',
  category: 'Customer Service',
  workflow_data: {
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": -13.297762769570795,
          "y": 347.42754644561535
        },
        "data": {
          "triggerType": "wpCore",
          "selectedWpCoreTrigger": "wp_insert_comment",
          "wpCoreTriggerConditions": {
            "commentType": "comment",
            "postType": "any"
          },
          "nodeName": "Comment Monitor"
        },
        "measured": {
          "width": 380,
          "height": 415
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "sentimentAnalysis-1",
        "type": "sentimentAnalysis",
        "position": {
          "x": 418.8325734795378,
          "y": 702.1810912922682
        },
        "data": {
          "nodeName": "Initial Sentiment Analysis",
          "content": "[[comment_content] from trigger-1]"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 547.528474047996,
          "y": 145.05694809599242
        },
        "data": {
          "nodeName": "Feedback Analysis",
          "model": "openai/chatgpt-4o-latest",
          "content": "Analyze this feedback in detail:\n\nComment: [[comment_content] from trigger-1]\nAuthor: [[comment_author] from trigger-1]\nEmail: [[comment_author_email] from trigger-1]\nPost Context: ID [[comment_post_id] from trigger-1]\nInitial Sentiment: [Input from sentimentAnalysis-1]\n\nProvide:\n1. Sentiment score (0-100)\n2. Primary emotion\n3. Key topics\n4. Priority level (low/medium/high/urgent)\n5. Response time recommendation\n6. Key points to address",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "condition-1",
        "type": "condition",
        "position": {
          "x": 855.2448749232908,
          "y": 675.9453283162662
        },
        "data": {
          "nodeName": "Urgency Check",
          "conditions": [
            {
              "input": "[Input from aiModel-1]",
              "comparison": "contains",
              "value": "urgent"
            }
          ],
          "conditionGroups": [
            {
              "type": "AND",
              "conditions": [
                {
                  "input": "",
                  "comparison": "equals",
                  "value": ""
                }
              ]
            }
          ],
          "workflowId": null
        },
        "measured": {
          "width": 350,
          "height": 425
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 1133.6389524724657,
          "y": 73.7642370239981
        },
        "data": {
          "nodeName": "Urgent Response",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create an urgent response:\n\nComment: [[comment_content] from trigger-1]\nAuthor: [[comment_author] from trigger-1]\nAnalysis: [Input from aiModel-1]\n\nCreate:\n1. Immediate response draft\n2. Action items\n3. Required team members\n4. Follow-up timeline\n5. Resolution steps",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 509
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-3",
        "type": "aiModel",
        "position": {
          "x": 1320.375853654597,
          "y": 650.0113883595477
        },
        "data": {
          "nodeName": "Standard Response",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create a standard response:\n\nComment: [[comment_content] from trigger-1]\nAuthor: [[comment_author] from trigger-1]\nAnalysis: [Input from aiModel-1]\n\nCreate:\n1. Response draft\n2. Action items\n3. Follow-up recommendations\n4. Improvement suggestions",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 616
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "humanInput-1",
        "type": "humanInput",
        "position": {
          "x": 1777.7904315106084,
          "y": 243.8268792997643
        },
        "data": {
          "nodeName": "Support Review",
          "inputType": "modification",
          "assignmentType": "role",
          "selectedRole": "support",
          "content": "=== FEEDBACK REVIEW ===\n\nComment: [[comment_content] from trigger-1]\nAuthor: [[comment_author] from trigger-1]\nEmail: [[comment_author_email] from trigger-1]\nPost: ID [[comment_post_id] from trigger-1]\n\nAnalysis: [Input from aiModel-1]\n\nProposed Response:\n[Input from aiModel-2]\n[Input from aiModel-3]",
          "instructions": "Review and modify the response as needed. Ensure tone and content are appropriate.",
          "selectedUser": "",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 770
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "output-1",
        "type": "output",
        "position": {
          "x": 2215.721097156501,
          "y": 239.19703877458744
        },
        "data": {
          "outputType": "save",
          "nodeName": "Feedback Database",
          "selectedTable": "feedback_analysis",
          "columns": [],
          "fieldMappings": {
            "comment_id": "[[comment_id] from trigger-1]",
            "comment_date": "[[comment_date] from trigger-1]",
            "comment_content": "[[comment_content] from trigger-1]",
            "author": "[[comment_author] from trigger-1]",
            "sentiment": "[Input from sentimentAnalysis-1]",
            "priority": "[Input from aiModel-1]",
            "response": "[Input from humanInput-1]"
          },
          "webhookUrl": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 535
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "sentimentAnalysis-1"
      },
      {
        "id": "e2-3",
        "source": "sentimentAnalysis-1",
        "target": "aiModel-1"
      },
      {
        "id": "e3-4",
        "source": "aiModel-1",
        "target": "condition-1"
      },
      {
        "id": "e4-5",
        "source": "condition-1",
        "target": "aiModel-2",
        "sourceHandle": "true"
      },
      {
        "id": "e5-6",
        "source": "condition-1",
        "target": "aiModel-3",
        "sourceHandle": "false"
      },
      {
        "id": "e6-7",
        "source": "aiModel-2",
        "target": "humanInput-1"
      },
      {
        "id": "e7-8",
        "source": "aiModel-3",
        "target": "humanInput-1"
      },
      {
        "id": "e8-9",
        "source": "humanInput-1",
        "target": "output-1"
      },
      {
        "id": "e9-10",
        "source": "trigger-1",
        "target": "aiModel-1"
      },
      {
        "id": "e10-11",
        "source": "trigger-1",
        "target": "aiModel-2"
      },
      {
        "id": "e11-12",
        "source": "trigger-1",
        "target": "aiModel-3"
      },
      {
        "id": "e12-13",
        "source": "trigger-1",
        "target": "humanInput-1"
      },
      {
        "id": "e13-14",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e14-15",
        "source": "aiModel-1",
        "target": "aiModel-3"
      },
      {
        "id": "e15-16",
        "source": "aiModel-1",
        "target": "humanInput-1"
      },
      {
        "id": "e16-17",
        "source": "trigger-1",
        "target": "output-1"
      },
      {
        "id": "e17-18",
        "source": "sentimentAnalysis-1",
        "target": "output-1"
      },
      {
        "id": "e18-19",
        "source": "aiModel-1",
        "target": "output-1"
      }
    ]
  }
},

  
'proposal-generation-system': {
  name: 'AI-Powered Proposal Generator',
  description: 'Researches your sales lead and prepares a sales personalised sales proposal for them',
  difficulty: 'Advanced',
  category: 'Sales',
  workflow_data: {
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": 0,
          "y": 250
        },
        "data": {
          "triggerType": "manual",
          "nodeName": "Prospect Information",
          "content": "Enter prospect details:\n\nCompany Name:\nWebsite:\nIndustry:\nContact Person:\nEmail:\nProject Requirements:\nBudget Range:\nTimeline:\nKey Decision Makers:\nSpecial Requirements:"
        },
        "measured": {
          "width": 380,
          "height": 582
        },
        "selected": true
      },
      {
        "id": "research-1",
        "type": "research",
        "position": {
          "x": 430,
          "y": 314
        },
        "data": {
          "nodeName": "Prospect Research",
          "model": "sonar",
          "content": "Research this company and industry:\n\nCompany: [Input from trigger-1]\nWebsite: [Input from trigger-1]\n\nResearch:\n1. Recent company developments\n2. Industry trends and challenges\n3. Current technology stack\n4. Company mission and values\n5. Market position\n6. Notable projects\n7. Key team members\n8. Social presence",
          "returnCitations": true,
          "temperature": 0.7,
          "searchContext": true,
          "citations": true,
          "searchDomainFilters": [],
          "citationQuality": "standard",
          "frequency_penalty": 0,
          "presence_penalty": 0,
          "top_p": 1,
          "top_k": 0,
          "search_recency_filter": "any",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 709
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 862,
          "y": 784
        },
        "data": {
          "nodeName": "Solution Designer",
          "model": "openai/chatgpt-4o-latest",
          "content": "Design a customized solution:\n\nRequirements: [Input from trigger-1]\nResearch: [Input from research-1]\n\nProvide:\n1. Solution Overview\n2. Key Features\n3. Implementation Phases\n4. Timeline Estimates\n5. Resource Requirements\n6. Success Metrics\n7. Risk Mitigation\n8. Value Propositions\n\nStructure with clear headings.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 723
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 876,
          "y": 54
        },
        "data": {
          "nodeName": "Budget Calculator",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create detailed project budget:\n\nSolution: [Input from aiModel-1]\nBudget Range: [Input from trigger-1]\n\nProvide breakdown of:\n1. Implementation Costs\n2. Resource Costs\n3. Timeline Payments\n4. Optional Features\n5. Support Packages\n6. Maintenance Costs\n\nList each item with cost and total.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 671
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-3",
        "type": "aiModel",
        "position": {
          "x": 1334,
          "y": -134.5
        },
        "data": {
          "nodeName": "Proposal Generator",
          "model": "x-ai/grok-2-1212",
          "content": "Create a professional proposal:\n\nClient Info: [Input from trigger-1]\nResearch: [Input from research-1]\nSolution: [Input from aiModel-1]\nBudget: [Input from aiModel-2]\n\nSections:\n1. Executive Summary\n2. Company Understanding\n3. Problem Statement\n4. Proposed Solution\n5. Implementation Plan\n6. Timeline\n7. Investment\n8. Team & Resources\n9. Expected Outcomes\n10. Next Steps",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 131072
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "humanInput-1",
        "type": "humanInput",
        "position": {
          "x": 1372,
          "y": 376
        },
        "data": {
          "nodeName": "Sales Review",
          "inputType": "modification",
          "assignmentType": "role",
          "selectedRole": "sales",
          "content": "Review Generated Proposal:\n\nClient Info:\n[Input from trigger-1]\n\nMarket Research:\n[Input from research-1]\n\nSolution & Budget:\n[Input from aiModel-1]\n[Input from aiModel-2]\n\nProposal Draft:\n[Input from aiModel-3]",
          "instructions": "Review and modify the proposal as needed. Ensure competitive positioning and value proposition are strong.",
          "selectedUser": "",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 1016
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-4",
        "type": "aiModel",
        "position": {
          "x": 1820,
          "y": -161.25
        },
        "data": {
          "nodeName": "Email Draft",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create a proposal email:\n\nContact: [Input from trigger-1]\nResearch: [Input from research-1]\nProposal: [Input from humanInput-1]\n\nWrite a professional email that:\n1. Is personally relevant\n2. Highlights key benefits\n3. States clear next steps\n4. Encourages response",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 458
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "output-1",
        "type": "output",
        "position": {
          "x": 1914,
          "y": 1074
        },
        "data": {
          "outputType": "save",
          "nodeName": "Save Records",
          "selectedTable": "proposals",
          "columns": [],
          "fieldMappings": {
            "created_date": "=NOW()",
            "company": "[Input from trigger-1]",
            "contact": "[Input from trigger-1]",
            "research": "[Input from research-1]",
            "proposal": "[Input from humanInput-1]",
            "budget": "[Input from aiModel-2]",
            "status": "Pending"
          },
          "webhookUrl": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 535
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "sendEmail-1",
        "type": "sendEmail",
        "position": {
          "x": 1836,
          "y": 332.5
        },
        "data": {
          "nodeName": "Send Proposal",
          "to": "[Input from trigger-1]",
          "subject": "[Input from aiModel-4]",
          "body": "<p>[Input from aiModel-4]</p>",
          "cc": "",
          "bcc": "",
          "useHtml": true,
          "attachments": [],
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 722
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "research-1"
      },
      {
        "id": "e1-3",
        "source": "trigger-1",
        "target": "aiModel-1"
      },
      {
        "id": "e1-4",
        "source": "trigger-1",
        "target": "aiModel-2"
      },
      {
        "id": "e1-5",
        "source": "trigger-1",
        "target": "aiModel-3"
      },
      {
        "id": "e1-6",
        "source": "trigger-1",
        "target": "humanInput-1"
      },
      {
        "id": "e1-7",
        "source": "trigger-1",
        "target": "aiModel-4"
      },
      {
        "id": "e1-8",
        "source": "trigger-1",
        "target": "sendEmail-1"
      },
      {
        "id": "e1-9",
        "source": "trigger-1",
        "target": "output-1"
      },
      {
        "id": "e2-3",
        "source": "research-1",
        "target": "aiModel-1"
      },
      {
        "id": "e2-5",
        "source": "research-1",
        "target": "aiModel-3"
      },
      {
        "id": "e2-6",
        "source": "research-1",
        "target": "humanInput-1"
      },
      {
        "id": "e2-7",
        "source": "research-1",
        "target": "aiModel-4"
      },
      {
        "id": "e2-9",
        "source": "research-1",
        "target": "output-1"
      },
      {
        "id": "e3-4",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e3-5",
        "source": "aiModel-1",
        "target": "aiModel-3"
      },
      {
        "id": "e3-6",
        "source": "aiModel-1",
        "target": "humanInput-1"
      },
      {
        "id": "e4-5",
        "source": "aiModel-2",
        "target": "aiModel-3"
      },
      {
        "id": "e4-6",
        "source": "aiModel-2",
        "target": "humanInput-1"
      },
      {
        "id": "e4-9",
        "source": "aiModel-2",
        "target": "output-1"
      },
      {
        "id": "e5-6",
        "source": "aiModel-3",
        "target": "humanInput-1"
      },
      {
        "id": "e6-7",
        "source": "humanInput-1",
        "target": "aiModel-4"
      },
      {
        "id": "e6-9",
        "source": "humanInput-1",
        "target": "output-1"
      },
      {
        "id": "e7-8",
        "source": "aiModel-4",
        "target": "sendEmail-1"
      },
      {
        "id": "e8-9",
        "source": "aiModel-4",
        "target": "output-1"
      }
    ]
  }
},

  
'market-intelligence-automation': {
  name: 'AI Market Intelligence Reporter',
  description: 'Automatically researches market, aggregates data and prepares a market report on your selected subject',
  difficulty: 'Expert',
  category: 'Business Intelligence',
  workflow_data: {
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": -262,
          "y": 168
        },
        "data": {
          "triggerType": "manual",
          "nodeName": "Intelligence Sources",
          "content": "Configure market intelligence sources:\n\n1. News Sources (URLs):\nExample: techcrunch.com, wired.com\n\n2. Competitor Websites:\nList competitors' URLs\n\n3. Industry Forums:\nExample: Relevant subreddits, forums\n\n4. Market Data Sources:\nExample: statista.com, markets.com\n\n5. Social Media:\nExample: Twitter hashtags, LinkedIn companies"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "firecrawl-1",
        "type": "firecrawl",
        "position": {
          "x": 184,
          "y": 44
        },
        "data": {
          "nodeName": "Web Scanner",
          "operation": "crawl",
          "url": "[Input from trigger-1]",
          "maxDepth": 2,
          "format": "markdown",
          "onlyMainContent": true,
          "waitFor": 1000,
          "allowExternalLinks": false,
          "limit": 50,
          "includeTags": [
            "article",
            "post",
            "blog"
          ],
          "excludeTags": [],
          "timeout": 30000,
          "isMobile": false,
          "extractType": "prompt",
          "extractPrompt": "",
          "extractFields": [],
          "ignoreSitemap": true,
          "allowBackwardLinks": false,
          "crawlResults": [],
          "selectedPages": [],
          "lastExecutionTime": null,
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 680
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "research-1",
        "type": "research",
        "position": {
          "x": 210,
          "y": 782
        },
        "data": {
          "nodeName": "Market Research",
          "model": "sonar",
          "content": "Research current market trends:\n\nFocus Areas:\n1. Industry trends\n2. Market growth metrics\n3. Competitive analysis\n4. Tech advancements\n5. Regulatory changes\n6. Consumer behavior\n7. Economic factors\n\nInclude key statistics and sources.",
          "returnCitations": true,
          "maxTokens": null,
          "temperature": 0.7,
          "searchContext": true,
          "citations": true,
          "searchDomainFilters": [],
          "citationQuality": "standard",
          "frequency_penalty": 0,
          "presence_penalty": 0,
          "top_p": 1,
          "top_k": 0,
          "search_recency_filter": "any",
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 459
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 680,
          "y": 68
        },
        "data": {
          "nodeName": "Data Analysis",
          "model": "openai/chatgpt-4o-latest",
          "content": "Analyze collected intelligence:\n\nWeb Content:\n[Input from firecrawl-1]\n\nMarket Research:\n[Input from research-1]\n\nProvide analysis of:\n1. Key Market Trends\n2. Significant Changes\n3. Competitor Activities\n4. Market Opportunities\n5. Potential Threats\n6. Future Predictions\n7. Important Metrics\n\nList each with supporting data.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 673
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-2",
        "type": "aiModel",
        "position": {
          "x": 678,
          "y": 792
        },
        "data": {
          "nodeName": "Strategic Insights",
          "model": "openai/chatgpt-4o-latest",
          "content": "Generate strategic insights:\n\nAnalysis:\n[Input from aiModel-1]\n\nResearch:\n[Input from research-1]\n\nProvide:\n1. Trend Impact Analysis\n2. Strategic Recommendations\n3. Risk Assessments\n4. Opportunity Details\n5. Competitive Strategy\n6. Action Items\n7. Technology Impact",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 433
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "aiModel-3",
        "type": "aiModel",
        "position": {
          "x": 1136,
          "y": 218
        },
        "data": {
          "nodeName": "Report Generator",
          "model": "openai/chatgpt-4o-latest",
          "content": "Create intelligence report:\n\nAnalysis: [Input from aiModel-1]\nInsights: [Input from aiModel-2]\nResearch: [Input from research-1]\n\nSections:\n1. Executive Summary\n2. Market Overview\n3. Trend Analysis\n4. Competition Analysis\n5. Opportunities & Threats\n6. Recommendations\n7. Key Metrics\n8. Sources\n\nFormat professionally with clear sections.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "top_p": 1,
            "top_k": 0,
            "frequency_penalty": 0,
            "presence_penalty": 0,
            "repetition_penalty": 1,
            "max_tokens": 16384
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 748
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "post-1",
        "type": "post",
        "position": {
          "x": 1598,
          "y": -74
        },
        "data": {
          "nodeName": "Create Report Post",
          "selectedPostType": "post",
          "postStatus": "draft",
          "fieldMappings": {
            "post_title": "Market Intelligence Report - {{date}}",
            "post_content": "[Input from aiModel-3]",
            "post_excerpt": "[Input from aiModel-2]",
            "post_category": "Market Intelligence"
          },
          "editorPreferences": {},
          "featuredImage": {
            "url": "",
            "id": null,
            "source": "external"
          },
          "productImages": [],
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 794
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "output-1",
        "type": "output",
        "position": {
          "x": 1660,
          "y": 950
        },
        "data": {
          "outputType": "save",
          "nodeName": "Save Report Data",
          "selectedTable": "market_intelligence",
          "columns": [],
          "fieldMappings": {
            "report_date": "=NOW()",
            "trends": "[Input from aiModel-1]",
            "insights": "[Input from aiModel-2]",
            "recommendations": "[Input from aiModel-2]",
            "metrics": "[Input from aiModel-1]",
            "report": "[Input from aiModel-3]"
          },
          "webhookUrl": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 535
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "sendEmail-1",
        "type": "sendEmail",
        "position": {
          "x": 2082.75,
          "y": 252
        },
        "data": {
          "nodeName": "Send Report",
          "to": "team@company.com",
          "subject": "Market Intelligence Update - {{date}}",
          "body": "<p>New Market Intelligence Report Key Trends: [Input from aiModel-1] Strategic Insights: [Input from aiModel-2] View full report in post: {{post_url}}</p>",
          "cc": "",
          "bcc": "",
          "useHtml": true,
          "attachments": [],
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 722
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "firecrawl-1"
      },
      {
        "id": "e2-3",
        "source": "trigger-1",
        "target": "research-1"
      },
      {
        "id": "e3-4",
        "source": "firecrawl-1",
        "target": "aiModel-1"
      },
      {
        "id": "e4-5",
        "source": "research-1",
        "target": "aiModel-1"
      },
      {
        "id": "e5-6",
        "source": "aiModel-1",
        "target": "aiModel-2"
      },
      {
        "id": "e6-7",
        "source": "aiModel-2",
        "target": "aiModel-3"
      },
      {
        "id": "e7-8",
        "source": "aiModel-3",
        "target": "post-1"
      },
      {
        "id": "e8-9",
        "source": "post-1",
        "target": "output-1"
      },
      {
        "id": "e9-10",
        "source": "post-1",
        "target": "sendEmail-1"
      },
      {
        "id": "e4-6",
        "source": "research-1",
        "target": "aiModel-2"
      },
      {
        "id": "e5-7",
        "source": "aiModel-1",
        "target": "aiModel-3"
      },
      {
        "id": "e4-7",
        "source": "research-1",
        "target": "aiModel-3"
      },
      {
        "id": "e6-8",
        "source": "aiModel-2",
        "target": "post-1"
      },
      {
        "id": "e5-9",
        "source": "aiModel-1",
        "target": "output-1"
      },
      {
        "id": "e6-9",
        "source": "aiModel-2",
        "target": "output-1"
      },
      {
        "id": "e7-9",
        "source": "aiModel-3",
        "target": "output-1"
      },
      {
        "id": "e5-10",
        "source": "aiModel-1",
        "target": "sendEmail-1"
      },
      {
        "id": "e6-10",
        "source": "aiModel-2",
        "target": "sendEmail-1"
      }
    ]
  }
},

'competitor-price-monitoring': {
  name: 'Automatic Competitor Price Monitoring and Adjustment',
  description: 'Automatically monitor your customers prices for products, and automatically adjust your prices according to that',
  difficulty: 'Expert',
  category: 'E-commerce',
  workflow_data: {
    "name": "Competitor Price Monitoring and Adjustment",
    "nodes": [
      {
        "id": "trigger-1",
        "type": "trigger",
        "position": {
          "x": -840.1130566541021,
          "y": 0
        },
        "data": {
          "nodeName": "Product URL Input",
          "triggerType": "manual",
          "content": "Enter competitor product URL to monitor"
        },
        "measured": {
          "width": 380,
          "height": 377
        },
        "selected": false,
        "dragging": false
      },
      {
        "id": "firecrawl-1",
        "type": "firecrawl",
        "position": {
          "x": -400,
          "y": 0
        },
        "data": {
          "nodeName": "Scrape Price",
          "operation": "scrape",
          "url": "[Input from trigger-1]",
          "format": "extract",
          "onlyMainContent": true,
          "includeTags": [
            "span",
            "div"
          ],
          "excludeTags": [],
          "waitFor": 2000,
          "timeout": 30000,
          "isMobile": false,
          "extractType": "prompt",
          "extractPrompt": "",
          "extractFields": [],
          "maxDepth": 2,
          "ignoreSitemap": true,
          "limit": 10,
          "allowBackwardLinks": false,
          "allowExternalLinks": false,
          "crawlResults": [],
          "selectedPages": [],
          "lastExecutionTime": null,
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 413
        }
      },
      {
        "id": "extractInformation-1",
        "type": "extractInformation",
        "position": {
          "x": 0,
          "y": 0
        },
        "data": {
          "nodeName": "Extract Price",
          "content": "[Input from firecrawl-1]",
          "extractionFields": [
            {
              "name": "price",
              "description": "Extract the numerical price value, remove currency symbols and formatting",
              "isList": false
            }
          ],
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 603
        }
      },
      {
        "id": "condition-1",
        "type": "condition",
        "position": {
          "x": 400,
          "y": 0
        },
        "data": {
          "nodeName": "Check Price Difference",
          "conditionGroups": [
            {
              "type": "AND",
              "conditions": [
                {
                  "input": "[price from extractInformation-1]",
                  "comparison": "lessThan",
                  "value": "our_current_price"
                }
              ]
            }
          ],
          "workflowId": null
        },
        "measured": {
          "width": 350,
          "height": 425
        }
      },
      {
        "id": "aiModel-1",
        "type": "aiModel",
        "position": {
          "x": 800,
          "y": -200
        },
        "data": {
          "nodeName": "Price Adjustment Strategy",
          "model": "openai/chatgpt-4o-latest",
          "content": "Based on the competitor's price of $[price from extractInformation-1], suggest a new competitive price for our product that maintains our profit margins while staying competitive. Consider our current price and provide a detailed reasoning for the suggested adjustment.",
          "imageUrls": [],
          "settings": {
            "temperature": 1,
            "max_tokens": 16384,
            "top_p": 1,
            "frequency_penalty": 0,
            "presence_penalty": 0
          },
          "workflowId": null
        },
        "measured": {
          "width": 380,
          "height": 520
        },
        "selected": false
      },
      {
        "id": "humaninput-1",
        "type": "humaninput",
        "position": {
          "x": 1200,
          "y": -200
        },
        "data": {
          "nodeName": "Price Approval"
        }
      },
      {
        "id": "database-1",
        "type": "output",
        "position": {
          "x": 1309.1803392577594,
          "y": -92.19616024210063
        },
        "data": {
          "nodeName": "Save Price History",
          "outputType": "save",
          "content": "",
          "displayOutput": "Output will be displayed here after execution",
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "selectedTable": "price_history",
          "webhookUrl": "",
          "columns": [],
          "webhookKeys": [],
          "workflowId": null,
          "selectedSpreadsheet": "",
          "selectedSheetTab": "",
          "columnMappings": {},
          "driveItemType": ""
        },
        "measured": {
          "width": 380,
          "height": 535
        },
        "selected": true,
        "dragging": false
      },
      {
        "id": "sendEmail-1",
        "type": "sendEmail",
        "position": {
          "x": 800,
          "y": 383.01582098434085
        },
        "data": {
          "nodeName": "Price Match Not Required",
          "to": "manager@company.com",
          "cc": "",
          "bcc": "",
          "subject": "Price Monitoring Report - No Action Required",
          "body": "<p>Competitor price ($[price from extractInformation-1]) is higher than our current price. No price adjustment is needed at this time.</p>",
          "useHtml": true,
          "delayEnabled": false,
          "delayValue": 1,
          "delayUnit": "minutes",
          "attachments": [],
          "workflowId": null
        },
        "measured": {
          "width": 400,
          "height": 722
        },
        "selected": false,
        "dragging": false
      }
    ],
    "edges": [
      {
        "id": "e1-2",
        "source": "trigger-1",
        "target": "firecrawl-1"
      },
      {
        "id": "e2-3",
        "source": "firecrawl-1",
        "target": "extractInformation-1"
      },
      {
        "id": "e3-4",
        "source": "extractInformation-1",
        "target": "condition-1"
      },
      {
        "id": "e4-5",
        "source": "condition-1",
        "target": "aiModel-1",
        "sourceHandle": "true"
      },
      {
        "id": "e5-6",
        "source": "aiModel-1",
        "target": "humaninput-1"
      },
      {
        "id": "e6-7",
        "source": "humaninput-1",
        "target": "database-1",
        "sourceHandle": "approve"
      },
      {
        "id": "e4-8",
        "source": "condition-1",
        "target": "sendEmail-1",
        "sourceHandle": "false"
      },
      {
        "type": "default",
        "animated": false,
        "source": "aiModel-1",
        "sourceHandle": "a",
        "target": "database-1",
        "id": "xy-edge__aiModel-1a-database-1"
      }
    ]
  }
},
    
  
  

};